import { useAtom } from 'jotai';
import { filterListBottomSheetAtom } from './filterListBottomSheet.atom';
import { filterListBottomSheetStore } from './FilterListBottomSheetAtomProvider';
import { useEffect } from 'react';
import { useFilterListAtom } from '../filterList/useFilterListAtom';

export const useFilterListBottomSheetAtom = () => {
  const [filterListBottomSheetAtomValue, setFilterListBottomSheetAtomValue] =
    useAtom(filterListBottomSheetAtom, { store: filterListBottomSheetStore });
  const { filterListAtomValue } = useFilterListAtom();

  useEffect(() => {
    setFilterListBottomSheetAtomValue(filterListAtomValue);
  }, [filterListAtomValue, setFilterListBottomSheetAtomValue]);

  /**
   * - queryName에 해당하는 key를 queryValue로 설정하는 경우 사용
   */
  const setFilterListBottomSheetViaQueryValue: SetFilterListBottomSheetViaQueryValue =
    ({ queryName, queryValue }) => {
      setFilterListBottomSheetAtomValue(prev => ({
        ...prev,
        [queryName]: queryValue,
      }));
    };

  const clearFilterListBottomSheet = () => {
    setFilterListBottomSheetAtomValue({});
  };
  return {
    filterListBottomSheetAtomValue,
    setFilterListBottomSheetViaQueryValue,
    clearFilterListBottomSheet,
  };
};

export type SetFilterListBottomSheetViaQueryValueProps = {
  queryName: string;
  queryValue: string | string[];
};

export type SetFilterListBottomSheetViaQueryValue = (
  props: SetFilterListBottomSheetViaQueryValueProps,
) => void;
